import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { AccountTab, buildAccountLink } from '../utils/accountRedirect';

interface AccountActionAlertProps {
  message: string;
  variant?: 'error' | 'warning';
  onDismiss?: () => void;
  /** Account tab that resolves the issue. */
  tab?: AccountTab;
}

export const AccountActionAlert: React.FC<AccountActionAlertProps> = ({
  message,
  variant = 'error',
  onDismiss,
  tab,
}) => {
  const { t } = useTranslation();
  const accountTo = buildAccountLink(tab);

  return (
    <div className={`alert alert-${variant}`}>
      <p style={{ margin: 0 }}>{message}</p>
      <p style={{ margin: '0.5rem 0 0' }}>
        <Link to={accountTo}>{t('manage.connect_required_link')}</Link>
      </p>
      {onDismiss && (
        <button type="button" className="dismiss" onClick={onDismiss} aria-label={t('ui.modal_close')}>
          &times;
        </button>
      )}
    </div>
  );
};
